import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useState } from "react";

function AppNavbar({
  brand = "Mini Market",
  links = [{ href: "/", label: "Home" }],
  isSignedIn = false,
  me = null,
  balance = null,
  onLogin,
  onLogout,
  onSignup,
}) {
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  return (
    <>
    <Navbar
      expand="lg"
      className="app-navbar mb-0 border-bottom"
      variant="dark"
    >
      <Container>
        <div className="d-flex align-items-center gap-3">
          <Navbar.Brand href="/" className="app-navbar-brand">
            {brand}
          </Navbar.Brand>
        </div>
        {
          !isSignedIn &&
          <div className="d-flex align-items-center gap-3 navbar-auth-actions">
                <Button
                  variant="outline-secondary"
                  className="auth-btn auth-btn-signin"
                  onClick={onLogin}
                >
                  Sign In
                </Button>
                <Button
                  variant="primary"
                  className="auth-btn auth-btn-signup"
                  onClick={onSignup}
                >
                  Sign Up
                </Button>
          </div>
        }
        {
          isSignedIn &&
          <>
          <Navbar.Toggle aria-controls="app-navbar-nav" />
          <Navbar.Collapse id="app-navbar-nav">
            <Nav className="me-auto">
              {links.map((link) => (
                <Nav.Link
                  key={link.href || link.label}
                  href={link.href}
                  className="app-navbar-link"
                >
                  {link.label}
                </Nav.Link>
              ))}
              <Nav.Link
                onClick={() => setShowOffcanvas(true)}
                className="app-navbar-link"
              >
                Account Info
              </Nav.Link>
            </Nav>
            <div className="d-flex align-items-center gap-3 navbar-auth-actions">
              {isSignedIn && (
                <Button
                  variant="outline-secondary"
                  className="auth-btn auth-btn-signout"
                  onClick={onLogout}
                >
                  Sign Out
                </Button>
              )}
            </div>
          </Navbar.Collapse>
          </>
        }
      </Container>
    </Navbar>
    <Offcanvas show={showOffcanvas} onHide={(e) => setShowOffcanvas(false)} className="app-offcanvas">
      <Offcanvas.Header closeButton></Offcanvas.Header>
      <Offcanvas.Body>
        <Stack gap={3}>
          <div className="app-offcanvas-section">
            <div className="app-offcanvas-label">User</div>
            <div className="app-offcanvas-value">{me?.username || me?.sub || "Unknown"}</div>
          </div>
          <div className="app-offcanvas-section">
            <div className="app-offcanvas-label">Available</div>
            <div className="app-offcanvas-value">{balance?.cash_available ?? "0.00"}</div>
          </div>
          <div className="app-offcanvas-section">
            <div className="app-offcanvas-label">Reserved</div>
            <div className="app-offcanvas-value">{balance?.cash_reserved ?? "0.00"}</div>
          </div>
        </Stack>
      </Offcanvas.Body>
    </Offcanvas>
    </>
  );
}

export default AppNavbar;
